<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />

    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <section id="description">
        <div class="row">
          <div class="col-md-12">
            <div class="card custom-card">
              <div class="candidate d-none d-sm-block" style="border-radius: 8px 8px 0 0">
                <div class="d-flex align-items-center">
                  <span v-if="!isInGlobalEditMode" class="candidate-name">
                    <b>{{ marketingEmployer.name }}</b>
                    <span class="candidate-edit mt-n1 ml-3">
                      <router-link to v-show="!isInGlobalEditMode">
                        <svgHelper
                          @click.native="changeGlobalEditMode()"
                          class="candidate-edit-icon"
                          name="edit"
                        ></svgHelper>
                      </router-link>
                    </span>
                  </span>

                  <span v-else class="candidate-name flex-grow-1 mr-2 my-auto">
                    <input
                      type="text"
                      class="form-control"
                      id="employer_name"
                      v-model="marketingEmployerEdit.name"
                    />
                  </span>
                  <div v-if="!isInGlobalEditMode" class="single-job-controls d-flex ml-auto">
                    <button
                      type="button"
                      class="btn btn-success add-employer-btn text-nowrap"
                      data-toggle="modal"
                      href="#addEmployerModal"
                    >
                      Add Employer
                    </button>
                  </div>

                  <div v-else class="form-buttons text-right ml-auto">
                    <button @click="updateEmployer" class="btn btn-primary ml-auto">Save</button>
                    <button @click="onCancelUpdateForm" class="btn btn-danger ml-2">Cancel</button>
                    <br />
                    <i
                      style="cursor: pointer; font-size: 21px"
                      data-toggle="modal"
                      href="#deleteEmployerModal"
                      class="fas fa-trash-alt mt-2"
                    ></i>
                  </div>
                </div>
              </div>

              <nav class="job-controls-tabs">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-primary-tab"
                    data-toggle="tab"
                    href="#nav-primary"
                    role="tab"
                    aria-controls="nav-primary"
                    aria-selected="true"
                    ><i class="far fa-credit-card d-block d-sm-none"></i> DETAILS</a
                  >
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-primary"
                  role="tabpanel"
                  aria-labelledby="nav-primary-tab"
                >
                  <form @submit.prevent="updateEmployer" ref="globalUpdateForm">
                    <!-- Editable info global -->
                    <div class="candidate d-block d-sm-none" style="border-radius: 8px 8px 0 0">
                      <figure class="employer-picture d-flex align-items-center">
                        <img
                          class="rounded-circle mr-3"
                          src="https://media-exp1.licdn.com/dms/image/C560BAQF_1BqcCYk5iw/company-logo_200_200/0?e=2159024400&v=beta&t=VIwymtUGPLl3EApxziNxNiYNmAJHRYrTq28-lPwErsM"
                          alt="avatar"
                        />
                        <!-- <div v-if="!isInGlobalEditMode" class="candidate-name d-none d-sm-block">
                          <b>{{ getEmployerById.name }}</b>
                          <span class="candidate-edit mt-n1 ml-3">
                            <router-link to v-show="!isInGlobalEditMode">
                              <svgHelper
                                @click.native="changeGlobalEditMode"
                                class="candidate-edit-icon"
                                name="edit"
                              />
                            </router-link>
                          </span>
                        </div>

                        <div v-else class="candidate-name my-auto">
                          <input
                            type="text"
                            class="form-control"
                            id="employer_name"
                            v-model="selectedFirstName"
                          />
                        </div> -->
                        <div class="single-job-controls ml-auto d-none d-sm-block">
                          <button
                            type="button"
                            class="btn btn-success add-job-btn"
                            style="white-space: nowrap; position: relative; top: 5px; right: 0"
                          >
                            <i class="fas fa-plus-circle mr-2"></i>Add Employer
                          </button>
                        </div>
                      </figure>
                    </div>

                    <ul class="list-group list-group-flush employer-details">
                      <div class="row">
                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.postalCodeFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.postalCode = true"
                            @mouseleave="editFields.postalCode = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Postal code</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.postalCode" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="postal-code"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{
                                marketingEmployer.postal_code ? marketingEmployer.postal_code : ''
                              }}
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Postal code</b>
                            </span>

                            <input
                              type="text"
                              class="form-control"
                              id="postal-code"
                              placeholder="Postal Code"
                              v-model="marketingEmployerEdit.postal_code"
                              autocomplete
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.postalCodeFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.city = true"
                            @mouseleave="editFields.city = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Location</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.city" to>
                                  <i
                                    @click="showEditForm($event)"
                                    id="city"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <div>
                                {{ marketingEmployer.city ? `${marketingEmployer.city}, ` : '' }}
                                {{ marketingEmployer.country ? marketingEmployer.country : '' }}
                              </div>
                            </div>
                          </div>

                          <span class="d-flex new-location" v-else>
                            <span class="mr-0">
                              <b>Location</b>
                            </span>
                            <div class="location-container">
                              <div class="location-container">
                                <v-select
                                  class="city-select mr-2"
                                  v-model="marketingEmployerEdit.country"
                                  @input="fetchCitiesByCountryIdNew($event)"
                                  label="name"
                                  placeholder="Country"
                                  :options="getAllCountries"
                                  :reduce="country => country"
                                  :clearable="false"
                                >
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching && search.length >= 3">
                                      No results found for <em>{{ search }}</em
                                      >.
                                    </template>
                                    <div style="opacity: 0.5" v-else>
                                      Please type at least 3 characters
                                    </div>
                                  </template>
                                </v-select>
                              </div>
                              <v-select
                                class="city-select mr-2"
                                v-model="marketingEmployerEdit.city"
                                label="name"
                                :options="getCitiesListByCountry"
                                :reduce="city => city"
                                :clearable="true"
                              >
                                <template v-slot:no-options>
                                  <div style="opacity: 0.5">Please select a country first</div>
                                </template>
                              </v-select>
                            </div>

                            <button
                              v-show="!isInGlobalEditMode"
                              type="submit"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>
                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.cityFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.phoneFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.phone = true"
                            @mouseleave="editFields.phone = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Recruiting agency</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.phone" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="phone"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <div class="custom-control custom-checkbox">
                                <input
                                  id="notification_1"
                                  class="mr-2 custom-control-input"
                                  type="checkbox"
                                  aria-label
                                  disabled
                                  v-model="marketingEmployer.recruting_agency"
                                />
                                <label class="custom-control-label" for="notification_1"> </label>
                              </div>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Recruiting agency</b>
                            </span>

                            <div class="new-phone">
                              <div class="custom-control custom-checkbox">
                                <input
                                  id="notification"
                                  class="mr-2 custom-control-input"
                                  type="checkbox"
                                  aria-label
                                  v-model="marketingEmployerEdit.recruting_agency"
                                />
                                <label class="custom-control-label" for="notification"> </label>
                              </div>

                              <button
                                v-show="!isInGlobalEditMode"
                                type="submit"
                                class="btn btn-outline btn-sm border mr-1"
                              >
                                <i class="fas fa-check"></i>
                              </button>

                              <CandidateEditFieldCancelBtn
                                v-show="!isInGlobalEditMode"
                                @clicked="editIconState.phoneFormShow = false"
                              >
                                <i class="fas fa-times"></i>
                              </CandidateEditFieldCancelBtn>
                            </div>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.emailSyncFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.emailSync = true"
                            @mouseleave="editFields.emailSync = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Employees</b>
                            </span>

                            <div style="position: relative; height: 18px">
                              <div class="edit-btn">
                                <router-link v-if="editFields.emailSync" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="email-sync"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              {{ marketingEmployer.employees }}
                            </div>
                            <div
                              v-if="getEmployerById.sync_imap_email"
                              @click="checkImapConnection"
                              class="test"
                              title="Test connection"
                            >
                              <i
                                :style="isConnected ? 'color:green' : 'color:#999'"
                                class="fas fa-envelope"
                              ></i>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Employees</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="email-sync"
                              placeholder="Employees"
                              v-model="marketingEmployerEdit.employees"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              style="margin-right: 12px"
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.emailSyncFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div
                            v-if="!editIconState.websiteFormShow && !isInGlobalEditMode"
                            @mouseover="editFields.website = true"
                            @mouseleave="editFields.website = false"
                            class="d-flex"
                          >
                            <span>
                              <b>Website</b>
                            </span>

                            <div style="position: relative">
                              <div class="edit-btn">
                                <router-link v-if="editFields.website" to class="mr-1">
                                  <i
                                    @click="showEditForm($event)"
                                    id="website"
                                    class="fas fa-pen edit-icon"
                                  ></i>
                                </router-link>
                              </div>
                              <a
                                v-if="marketingEmployer.website"
                                :href="marketingEmployer.website"
                                target="_blank"
                                >{{ marketingEmployer.website | prettifyUrl }}</a
                              >
                              <span v-else></span>
                            </div>
                          </div>

                          <span class="d-flex" v-else>
                            <span class="mr-0">
                              <b>Website</b>
                            </span>

                            <input
                              style="margin-right: 12px"
                              type="text"
                              class="form-control"
                              id="website"
                              placeholder="Website"
                              v-model="marketingEmployerEdit.website"
                            />

                            <button
                              type="submit"
                              v-show="!isInGlobalEditMode"
                              class="btn btn-outline btn-sm border mr-1"
                            >
                              <i class="fas fa-check"></i>
                            </button>

                            <CandidateEditFieldCancelBtn
                              v-show="!isInGlobalEditMode"
                              @clicked="editIconState.websiteFormShow = false"
                            >
                              <i class="fas fa-times"></i>
                            </CandidateEditFieldCancelBtn>
                          </span>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Created by</span>
                            <span>{{
                              marketingEmployer.creator ? marketingEmployer.creator : ''
                            }}</span>
                          </div>
                        </li>

                        <li class="list-group-item col-md-6">
                          <div class="d-flex">
                            <span class="mr-3">Created date</span>
                            <span>{{
                              marketingEmployer.created_at
                                | formatDate({
                                  format: getUserProfile.format_date,
                                  timezone: getUserProfile.timezone,
                                  hasHourAndMinutes: false,
                                })
                            }}</span>
                          </div>
                        </li>
                      </div>
                    </ul>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>

      <section id="description">
        <div class="row">
          <div class="col-md-12">
            <div class="card custom-card">
              <div class="controls-wrap">
                <div class="user-controls d-none d-sm-block">
                  <!-- <h5 style="font-weight: 700">Users & Logs</h5> -->
                  <div class="d-flex align-items-start">
                    <nav class="job-controls-tabs w-100">
                      <div
                        class="nav nav-tabs"
                        id="nav-tab"
                        role="tablist"
                        style="border-bottom: none!important;"
                      >
                        <a
                          @click="tab = 1"
                          class="nav-item nav-link active"
                          id="nav-users-tab"
                          data-toggle="tab"
                          href="#nav-users"
                          role="tab"
                          aria-controls="nav-users"
                          aria-selected="true"
                          >Contacts</a
                        >
                        <a
                          @click="tab = 2"
                          class="nav-item nav-link"
                          id="nav-logs-tab"
                          data-toggle="tab"
                          href="#nav-logs"
                          role="tab"
                          aria-controls="nav-logs"
                          aria-selected="false"
                          >Recruiters</a
                        >
                        <button
                          v-if="tab === 1"
                          type="button"
                          data-toggle="modal"
                          href="#addUserModalUserManagment"
                          class="btn btn-success ms-auto"
                          style="white-space: nowrap;"
                        >
                          Add Contact
                        </button>
                      </div>
                    </nav>
                  </div>
                </div>

                <div class="tab-content m-0" id="nav-tabContent-users">
                  <section
                    class="tab-pane fade show active"
                    id="nav-users"
                    role="tabpanel"
                    aria-labelledby="nav-users-tab"
                  >
                    <div class="controls-wrap">
                      <div class="tab-content m-0" id="nav-tabContent-users">
                        <section
                          class="tab-pane fade show active"
                          id="nav-users"
                          role="tabpanel"
                          aria-labelledby="nav-users-tab"
                        >
                          <div style="min-height: 300px;" class="scroller">
                            <table class="table table-striped custom-table desktop-only-table">
                              <thead class="bg-dark">
                                <tr>
                                  <th nowrap scope="col">Name</th>
                                  <th nowrap scope="col">Email</th>
                                  <th nowrap scope="col">Title</th>
                                  <th nowrap scope="col"></th>
                                  <th nowrap scope="col">Advertised job</th>
                                  <th nowrap scope="col">Score</th>
                                  <th nowrap scope="col">Toxicity</th>
                                  <th nowrap scope="col">Hubspot</th>
                                  <th nowrap scope="col">Created By</th>
                                  <th nowrap scope="col">Created</th>
                                  <th nowrap scope="col">&nbsp;</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr v-for="contact in contacts" :key="contact.id">
                                  <td>{{ contact.first_name }} {{ contact.last_name }}</td>
                                  <td>
                                    <div style="display: flex; align-items: center; gap: 8px;">
                                      <popper
                                        :append-to-body="true"
                                        trigger="hover"
                                        :options="{
                                          placement: 'top',
                                          modifiers: { offset: { offset: '10,20px' } },
                                        }"
                                      >
                                        <div class="popper">
                                          {{
                                            contact.email_premutator_status === 0
                                              ? 'Single email'
                                              : 'Email permutator'
                                          }}
                                        </div>
                                        <div slot="reference">
                                          <div
                                            :style="getIconColor(contact.email_premutator_status)"
                                            style="display: flex; align-items: center;"
                                            v-html="
                                              contact.email_premutator_status === 0
                                                ? mailIcon
                                                : multipleMailIcon
                                            "
                                          ></div>
                                        </div>
                                      </popper>

                                      <popper
                                        :append-to-body="true"
                                        trigger="hover"
                                        :options="{
                                          placement: 'top',
                                          modifiers: { offset: { offset: '10,20px' } },
                                        }"
                                      >
                                        <div class="popper">
                                          {{ getLanguageName(contact.language) }}
                                        </div>
                                        <div
                                          slot="reference"
                                          style="display: flex; align-items: center;"
                                        >
                                          <span
                                            :class="`fi fi-${getLanguageFlag(contact.language)}`"
                                            style="border-radius: 2px; width: 20px; height: 15px; line-height: 15px; display: inline-block;"
                                          ></span>
                                        </div>
                                      </popper>

                                      <a :href="`mailto:${contact.email}`"> {{ contact.email }}</a>
                                    </div>
                                  </td>

                                  <td>
                                    <div class="text-truncate" style="width: 167px;">
                                      {{ contact.title }}
                                    </div>
                                  </td>

                                  <td v-if="contact.linkedin">
                                    <a rel="nofollow" target="_blank" :href="contact.linkedin">
                                      <div
                                        style="width: 26px; height: 26px; fill: #0a66c2;"
                                        v-html="linkedinIcon"
                                      ></div
                                    ></a>
                                  </td>
                                  <td v-else></td>
                                  <td>{{ contact.advertised_job }}</td>
                                  <td>{{ contact.bouncer_score }}</td>
                                  <td>{{ contact.bouncer_toxicity }}</td>

                                  <td
                                    :style="{
                                      backgroundColor: contact.hubspot_submitted ? '#f05a00' : '',
                                      color: contact.hubspot_submitted ? '#fff' : '',
                                      opacity: contact.only_newsletter === true ? 0.5 : 1,
                                    }"
                                  >
                                    <span v-if="contact.hubspot_submitted">
                                      {{
                                        contact.hubspot_submitted
                                          | formatDate({
                                            format: getUserProfile.format_date,
                                            timezone: getUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </span>
                                    <span v-else>
                                      {{ contact.exists_in_hubspot ? 'Existed' : '' }}
                                    </span>
                                  </td>
                                  <td style="white-space:nowrap;">{{ contact.created_by }}</td>
                                  <td>
                                    {{
                                      contact.created_at
                                        | formatDate({
                                          format: getUserProfile.format_date,
                                          timezone: getUserProfile.timezone,
                                          hasHourAndMinutes: false,
                                        })
                                    }}
                                  </td>

                                  <td id="actions">
                                    <div class="icon-wrapper d-flex align-items-center">
                                      <button
                                        @click="setAction(contact, 'edit')"
                                        data-bs-target="#actionModal"
                                        data-bs-toggle="modal"
                                        class="btn btn-link"
                                      >
                                        <svgHelper class="edit" name="edit" />
                                      </button>
                                      <button
                                        v-if="
                                          getAccType === 'admin' &&
                                            contact.email_premutator_status === 0
                                        "
                                        @click="
                                          contact.hubspot_submitted && !contact.exists_in_hubspot
                                            ? ''
                                            : setAction(contact, 'submit')
                                        "
                                        type="button"
                                        :data-bs-target="
                                          contact.hubspot_submitted && !contact.exists_in_hubspot
                                            ? ''
                                            : `#actionModal`
                                        "
                                        data-bs-toggle="modal"
                                        class="btn btn-link"
                                        :style="
                                          contact.hubspot_submitted && !contact.exists_in_hubspot
                                            ? 'opacity:0.5; cursor:disabled'
                                            : ''
                                        "
                                      >
                                        <svgHelper class="submit" name="submitPipeline" />
                                      </button>

                                      <button
                                        v-if="
                                          getAccType === 'admin' &&
                                            contact.email_premutator_status != 0
                                        "
                                        @click="
                                          contact.exists_in_hubspot
                                            ? setAction(contact, 'submit')
                                            : ''
                                        "
                                        type="button"
                                        :data-bs-target="
                                          contact.exists_in_hubspot ? `#actionModal` : ''
                                        "
                                        data-bs-toggle="modal"
                                        class="btn btn-link"
                                        :style="
                                          !contact.exists_in_hubspot
                                            ? 'opacity:0.5; cursor:disabled'
                                            : ''
                                        "
                                      >
                                        <svgHelper class="submit" name="submitPipeline" />
                                      </button>
                                      <button
                                        v-if="getAccType === 'admin'"
                                        @click="setAction(contact, 'delete')"
                                        class="btn btn-link"
                                        data-bs-toggle="modal"
                                        data-bs-target="#actionModal"
                                      >
                                        <svgHelper class="delete" name="delete" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </section>
                      </div>
                    </div>
                    <div class="d-flex ms-auto mt-auto bottom-controls">
                      <div class="d-none d-sm-block ms-auto" id="pagination">
                        <!-- Pagination -->

                        <Pagination
                          :currentPage="currentPage"
                          :totalPages="totalPages"
                          @nextPage="nextPage"
                          @prevPage="previousPage"
                          @selectPageByNumber="setPageByNumber"
                          @firstPage="setToFirstPage"
                          @lastPage="setToLastPage"
                        />
                      </div>
                    </div>
                  </section>

                  <section
                    class="tab-pane fade"
                    id="nav-logs"
                    role="tabpanel"
                    aria-labelledby="nav-logs-tab"
                  >
                    <div class="scroller">
                      <table class="table table-striped custom-table" style="table-layout: auto;">
                        <thead class="bg-dark">
                          <tr>
                            <th nowrap scope="col">Name</th>
                            <th nowrap scope="col"></th>
                            <th nowrap scope="col">Title</th>
                            <th nowrap scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(contact, index) in recruiters" :key="index">
                            <td nowrap scope="col">{{ contact.name }}</td>
                            <td v-if="contact.linkedin">
                              <a rel="nofollow" target="_blank" :href="contact.linkedin">
                                <div
                                  style="width: 26px; height: 26px; fill: #0a66c2;"
                                  v-html="linkedinIcon"
                                ></div
                              ></a>
                            </td>
                            <td v-else></td>
                            <td nowrap scope="col">{{ contact.title }}</td>
                            <td>
                              <div
                                @click="setContact(contact.name, contact.title, contact.linkedin)"
                              >
                                <svgHelper
                                  type="button"
                                  data-toggle="modal"
                                  href="#addUserModalUserManagment"
                                  class="submit"
                                  style="fill: #5bb75b; cursor: pointer; width: 23px;"
                                  name="submitPipeline"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <span class="bottom-controls d-flex ml-auto w-10">
                      <div id="pagination" class="desktop-only ml-auto"></div>
                    </span>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>

      <section id="description">
        <div class="row">
          <div class="col-md-12">
            <div class="card custom-card">
              <div class="controls-wrap">
                <div class="header-contacts">
                  <h6 style="font-weight: 700">Jobs</h6>

                  <button
                    type="button"
                    data-toggle="modal"
                    href="#addJobModal"
                    class="btn btn-success"
                    style="white-space: nowrap;"
                  >
                    Add Job
                  </button>
                </div>
                <div class="tab-content m-0" id="nav-tabContent-users">
                  <section
                    class="tab-pane fade show active"
                    id="nav-users"
                    role="tabpanel"
                    aria-labelledby="nav-users-tab"
                  >
                    <div class="scroller" style="min-height: 300px;">
                      <table class="table table-striped custom-table desktop-only-table">
                        <thead class="bg-dark">
                          <tr>
                            <th nowrap scope="col">Title</th>
                            <th nowrap scope="col">Office</th>
                            <th nowrap scope="col">Location</th>
                            <th nowrap scope="col"></th>
                            <th nowrap scope="col">Contacts</th>
                            <th nowrap scope="col">Discovered</th>
                            <th nowrap scope="col">Checked</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="job in jobs" :key="job.mm_job_id">
                            <td>
                              <router-link
                                :to="{
                                  name: 'job_marketing_id',
                                  params: { job_id: job.mm_job_id },
                                }"
                                >{{ job.job_title }}</router-link
                              >
                            </td>
                            <td>
                              {{ job.office ? job.office : '' }}
                            </td>
                            <td>
                              {{ job.city ? `${job.city}, ` : '' }}
                              {{ job.country ? job.country : '' }}
                            </td>
                            <td>
                              <div class="icons">
                                <popper
                                  trigger="hover"
                                  :options="{
                                    placement: 'top',
                                    modifiers: { offset: { offset: '0,10px' } },
                                  }"
                                >
                                  <div class="popper">
                                    {{ job.url ? 'Job URL' : 'N/A' }}
                                  </div>
                                  <div slot="reference">
                                    <a :href="job.url" rel="nofollow" target="_blank"
                                      ><svgHelper
                                        :name="job.url ? 'relocate' : 'relocateFalse'"
                                      ></svgHelper
                                    ></a>
                                  </div>
                                </popper>

                                <popper
                                  trigger="hover"
                                  :options="{
                                    placement: 'top',
                                    modifiers: { offset: { offset: '0,10px' } },
                                  }"
                                >
                                  <div class="popper">
                                    {{ getWorkPlacePopper(job.workplace) }}
                                  </div>
                                  <div slot="reference">
                                    <div v-html="getWorkPlace(job.workplace)" />
                                  </div>
                                </popper>

                                <popper
                                  trigger="hover"
                                  :options="{
                                    placement: 'top',
                                    modifiers: { offset: { offset: '0,10px' } },
                                  }"
                                >
                                  <div class="popper">
                                    {{ job.full_time ? `Full-time` : `Part-time` }}
                                  </div>
                                  <div slot="reference">
                                    <div
                                      style="width: 25px; height: 25px;"
                                      :style="job.full_time ? `fill:#000` : `fill:#999`"
                                      v-html="fulltimeSvg"
                                    />
                                  </div>
                                </popper>
                              </div>
                            </td>
                            <td>
                              {{ job.mm_employer_approved_contacts_count }} /
                              {{ job.mm_employer_contacts_count }} / {{ job.hiring_team_count }}
                            </td>

                            <td>{{ job.created_at }}</td>
                            <td style="cursor: pointer;">
                              <popper
                                trigger="hover"
                                :options="{
                                  placement: 'left',
                                  modifiers: { offset: { offset: '0,10px' } },
                                }"
                              >
                                <div style="font-size: 14px;" class="popper">
                                  {{ !job.checked_by ? 'Check job' : 'Uncheck job' }}
                                </div>
                                <div slot="reference">
                                  <i
                                    @click="
                                      setJobForCheck(job.mm_job_id, !job.checked_by ? true : false)
                                    "
                                    type="button"
                                    data-toggle="modal"
                                    href="#addUserModalUserManagmentCheck"
                                    style="font-size: 18px; color: #999;"
                                    class="fas fa-check"
                                    :style="job.checked_by ? 'color: #ff741e ' : ''"
                                  ></i>
                                </div>
                              </popper>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="d-flex ms-auto mt-auto bottom-controls">
                      <div class="d-none d-sm-block ms-auto" id="pagination">
                        <!-- Pagination -->

                        <Pagination
                          :currentPage="currentPageNew"
                          :totalPages="totalPagesNew"
                          @nextPage="nextPageNew"
                          @prevPage="previousPageNew"
                          @selectPageByNumber="setPageByNumberNew"
                          @firstPage="setToFirstPageNew"
                          @lastPage="setToLastPageNew"
                        />
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">Add Contact</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUser"
              @click="clearFieldsAddContact"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div v-if="bouncer.error === 0" class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input
                    id="name"
                    type="text"
                    class="form-control"
                    v-model="addContact.first_name"
                  />
                  <label for="name">First Name</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="lastname"
                    type="text"
                    class="form-control"
                    v-model="addContact.last_name"
                  />
                  <label for="lastname">Last Name</label>
                </div>

                <div class="form-group m-label-left">
                  <input id="email" type="text" class="form-control" v-model="addContact.email" />
                  <label for="email">Email</label>
                </div>

                <div class="form-group m-label-left">
                  <input id="title" type="text" class="form-control" v-model="addContact.title" />
                  <label for="title">Title</label>
                </div>

                <div class="row">
                  <div class="form-group m-label col-md-5 newmarket no-hor">
                    <v-select
                      id="country-code"
                      @input="addCountryCode(countryCode)"
                      style="font-size: 14px; height: 42px"
                      v-model="countryCode"
                      :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                      :clearable="false"
                    >
                      <template v-slot:option="option">
                        {{ option.label }}
                      </template>
                    </v-select>
                    <label for="country-code">Country Code</label>
                  </div>

                  <div class="form-group m-label-left col-md-7">
                    <input
                      id="phone"
                      type="text"
                      class="form-control"
                      v-model="addContact.phone_number"
                    />
                    <label for="phone">Phone number</label>
                  </div>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="linkedin"
                    type="text"
                    class="form-control"
                    v-model="addContact.linkedIn"
                  />
                  <label style="text-transform:unset!important" for="linkedin">linkedIn</label>
                </div>

                <div class="form-group m-label-left">
                  <select v-model="addContact.language" class="form-control">
                    <option value="Danish">Danish</option>
                    <option value="Dutch">Dutch</option>
                    <option value="English">English</option>
                    <option value="Finnish">Finnish</option>
                    <option value="French">French</option>
                    <option value="German">German</option>
                    <option value="Icelandic">Icelandic</option>
                    <option value="Norwegian">Norwegian</option>
                    <option value="Polish">Polish</option>
                    <option value="Spanish">Spanish</option>
                    <option value="Swedish">Swedish</option>
                  </select>
                  <label style="text-transform:unset!important" for="linkedin">Language</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="adjob"
                    type="text"
                    class="form-control"
                    v-model="addContact.advertised_job"
                  />
                  <label for="adjob">Advertised job</label>
                </div>
                <div style="margin-left: 4px;" class="form-check addcont">
                  <input
                    v-model="addContact.only_newsletter"
                    class="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Only include for
                    <span style="text-transform: capitalize!important;">Tech Talents Insights</span>
                    Newsletter
                  </label>
                </div>
              </div>
            </div>

            <div v-if="bouncer.error === 1">
              <p>
                The contact could not be added for marketing automation in HubSpot as the email
                verification failed.
              </p>
              <ul class="list-unstyled">
                <li><strong>Status:</strong> {{ bouncer.bouncer_status }}</li>
                <li><strong>Reason:</strong> {{ bouncer.bouncer_reason }}</li>
                <li><strong>Score:</strong> {{ bouncer.bouncer_score }}</li>
                <li><strong>Toxicity:</strong> {{ bouncer.bouncer_toxicity }}</li>
              </ul>
              <!--        <p>{{ bouncer.data }}</p> -->
            </div>
          </div>

          <div v-if="bouncer.error === 0" class="modal-footer text-center justify-content-center">
            <p style="text-align: left;" class="mb-3">
              If you enter a wildcard (*) before the domain name of the email address, such as
              *@comstream.eu, the system will use an algorithm to attempt to guess the email
              address.
            </p>
            <button
              :disabled="isAdding || isContactEmpty"
              @click="addUserContact"
              type="button"
              class="btn btn-primary"
            >
              Add Contact
            </button>

            <button
              @click="clearFieldsAddContact"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>

          <div v-if="bouncer.error === 1" class="modal-footer text-center justify-content-center">
            <button type="button" class="btn btn-secondary" @click="bouncer.error = 0">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-job-modal"
      id="addJobModal"
      tabindex="-1"
      aria-labelledby="addJobModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addJobModal">Add job</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeJob"
              @click="clearJobFields"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div v-if="addJob.step === 1">
                  <div class="form-group m-label-left">
                    <input id="title" type="text" class="form-control" v-model="addJob.title" />
                    <label for="title">Title</label>
                  </div>

                  <div class="form-group m-label-left marketing-employer">
                    <v-select
                      id="country"
                      class="country-select"
                      v-model="addJob.country"
                      @input="
                        fetchCitiesByCountryIdAdd($event);
                        addJob.city = '';
                      "
                      label="name"
                      :options="getAllCountries"
                      :reduce="country => country"
                      :clearable="false"
                    >
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching && search.length >= 3">
                          No results found for <em>{{ search }}</em
                          >.
                        </template>
                        <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                      </template>
                    </v-select>
                    <label for="city">Country</label>
                  </div>
                  <div class="form-group m-label-left marketing-employer">
                    <v-select
                      :disabled="addJob.country === ''"
                      class="city-select"
                      v-model="addJob.city"
                      label="name"
                      :options="getCitiesListByCountry"
                      :reduce="city => city"
                      :clearable="true"
                    >
                      <template v-slot:no-options>
                        <div style="opacity: 0.5">Please select a country first</div>
                      </template>
                    </v-select>
                    <label for="city">City</label>
                  </div>
                </div>

                <div v-show="addJob.step === 2">
                  <div class="form-group m-label-left">
                    <select
                      id="workplace"
                      v-model="addJob.workplace"
                      class="form-select my-3 w-100"
                    >
                      <option value="1">Onsite</option>
                      <option value="2">Hybrid</option>
                      <option value="3">Remote</option>
                    </select>
                    <label for="workplace">Workplace</label>
                  </div>

                  <div class="form-group m-label-left">
                    <input id="url" type="text" class="form-control" v-model="addJob.url" />
                    <label style="text-transform: uppercase!important;" for="url">URL</label>
                  </div>

                  <div class="form-group m-label-left">
                    <TextEditor v-model="addJob.description" />
                    <label for="description">Description</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <div v-show="addJob.step === 1" class="addjb">
              <button
                @click="clearJobFields"
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                :disabled="addJob.country && !addJob.title"
                @click="changeStep(2)"
                type="button"
                class="btn btn-primary"
              >
                Next
              </button>
            </div>

            <div v-show="addJob.step === 2" class="addjb">
              <button @click="changeStep(1)" type="button" class="btn btn-secondary">
                Back
              </button>
              <button
                :disabled="isAdding"
                @click="addJobForEmployer"
                type="button"
                class="btn btn-primary"
              >
                Add job
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagmentCheck"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagmentCheck"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagmentCheck">
              {{ check.status != true ? 'Uncheck Job' : 'Check Job' }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUserCheckNeww"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 20px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p>
                  {{
                    check.status != true
                      ? 'Please confirm that you want to mark the Job as unchecked.'
                      : 'Please confirm that you want to mark the Job as checked.'
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="checkJob(check.jobId, check.status)"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addEmployerModal"
      tabindex="-1"
      aria-labelledby="addEmployerModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addEmployerModal">
              Add Employer
            </h5>
            <button
              @click="clearEmployerFields"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUserCheck"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 20px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input id="name" type="text" class="form-control" v-model="addEmployer.name" />
                  <label for="name">Name</label>
                </div>

                <div class="form-group m-label-left marketing-employer">
                  <v-select
                    id="country"
                    class="country-select"
                    v-model="addEmployer.country"
                    @input="
                      fetchCitiesByCountryIdAdd($event);
                      addEmployer.city = '';
                    "
                    label="name"
                    :options="getAllCountries"
                    :reduce="country => country"
                    :clearable="false"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching && search.length >= 3">
                        No results found for <em>{{ search }}</em
                        >.
                      </template>
                      <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                    </template>
                  </v-select>
                  <label for="city">Country</label>
                </div>

                <div class="form-group m-label-left marketing-employer">
                  <v-select
                    :disabled="addEmployer.country === ''"
                    class="city-select"
                    v-model="addEmployer.city"
                    label="name"
                    :options="getCitiesListByCountry"
                    :reduce="city => city"
                    :clearable="true"
                  >
                    <template v-slot:no-options>
                      <div style="opacity: 0.5">Please select a country first</div>
                    </template>
                  </v-select>
                  <label for="city">City</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="website"
                    type="text"
                    class="form-control"
                    v-model="addEmployer.website"
                  />
                  <label for="website">Website</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              :disabled="isAdding"
              @click="addNewEmployer"
              type="button"
              class="btn btn-primary"
            >
              Confirm
            </button>

            <button
              @click="clearEmployerFields"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade edit-modal"
      id="deleteEmployerModal"
      tabindex="-1"
      aria-labelledby="deleteEmployerModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteEmployerModal">Delete Employer</h5>
            <button
              ref="closeModalBtnDel"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to delete <strong>{{ marketingEmployer.name }}</strong
              >.
            </p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              :disabled="isAdding"
              @click="removeEmployer"
              type="button"
              class="btn btn-primary"
            >
              Delete
            </button>

            <button
              ref="closeModalBtn"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade add-user-modal"
      id="actionModal"
      tabindex="-1"
      aria-labelledby="actionModalLabel"
      aria-hidden="true"
      data-bs-keyboard="false"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="action === 'edit'" class="modal-title" id="actionModalLabel">Edit contact</h5>
            <h5 v-else-if="action === 'submit'" class="modal-title" id="actionModalLabel">
              Submit contact
            </h5>
            <h5 v-else="action === 'delete'" class="modal-title" id="actionModalLabel">
              Delete contact
            </h5>
            <button
              @click="countryCode = ''"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="actionModalClose"
            ></button>
          </div>

          <div class="modal-body" style="padding: 20px 20px">
            <div v-if="action === 'delete'" class="d-flex align-items-center">
              Please confirm that you want this contact to be deleted.
            </div>

            <div v-if="action === 'edit'" class="form-group flex-grow-1 mr-2">
              <div class="form-group m-label-left">
                <input id="name" type="text" class="form-control" v-model="contact.first_name" />
                <label for="name">First Name</label>
              </div>

              <div class="form-group m-label-left">
                <input id="lastname" type="text" class="form-control" v-model="contact.last_name" />
                <label for="lastname">Last Name</label>
              </div>

              <div class="form-group m-label-left">
                <input
                  disabled
                  id="email"
                  type="text"
                  class="form-control"
                  v-model="contact.email"
                />
                <label for="email">Email</label>
              </div>

              <div class="form-group m-label-left">
                <input id="title" type="text" class="form-control" v-model="contact.title" />
                <label for="title">Title</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-5 newmarket no-hor">
                  <v-select
                    id="country-code"
                    @input="addCountryCodeContact(countryCode)"
                    style="font-size: 14px; height: 42px"
                    v-model="countryCode"
                    :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                    :clearable="false"
                  >
                    <template v-slot:option="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                  <label for="country-code">Country Code</label>
                </div>

                <div class="form-group m-label-left col-md-7">
                  <input
                    id="phone"
                    type="text"
                    class="form-control"
                    v-model="contact.phone_number"
                  />
                  <label for="phone">Phone number</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <input id="linkedin" type="text" class="form-control" v-model="contact.linkedin" />
                <label style="text-transform:unset!important" for="linkedin">linkedIn</label>
              </div>

              <div class="form-group m-label-left">
                <select v-model="contact.language" class="form-control">
                  <option value="danish">Danish</option>
                  <option value="dutch">Dutch</option>
                  <option value="english">English</option>
                  <option value="finnish">Finnish</option>
                  <option value="french">French</option>
                  <option value="german">German</option>
                  <option value="icelandic">Icelandic</option>
                  <option value="norwegian">Norwegian</option>
                  <option value="polish">Polish</option>
                  <option value="spanish">Spanish</option>
                  <option value="swedish">Swedish</option>
                </select>
                <label style="text-transform:unset!important" for="linkedin">Language</label>
              </div>

              <div class="form-group m-label-left">
                <input
                  id="adjob"
                  type="text"
                  class="form-control"
                  v-model="contact.advertised_job"
                />
                <label for="adjob">Advertised job</label>
              </div>
              <div style="margin-left: 5px; margin-bottom: 12px;" class="form-check addcont">
                <input
                  disabled
                  v-model="contact.only_newsletter"
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                />
                <label
                  style="opacity: 1!important; color: #111!important;"
                  class="form-check-label"
                  for="flexCheckDefault"
                >
                  Only include for
                  <span style="text-transform: capitalize!important;">Tech Talents Insights</span>
                  Newsletter
                </label>
              </div>
              <p>
                If the contact has previously been submitted to HubSpot, saving will cause the
                information there to be updated.
              </p>
            </div>

            <div v-if="action === 'submit'" class="d-flex align-items-center">
              Please confirm that you want this contact to be added to or updated in HubSpot. The
              contact will be added regardless of the results from the email verification. If the
              contact already exists in HubSpot, some of its data may be overwritten.
            </div>
          </div>

          <div v-if="action === 'delete'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="deleteContact(contact.id)"
              type="button"
              class="btn btn-primary"
            >
              Delete
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>

          <div v-if="action === 'edit'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="editContact"
              type="button"
              class="btn btn-primary"
            >
              Save
            </button>
            <button
              @click="countryCode = ''"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>

          <div v-if="action === 'submit'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="submitContact"
              type="button"
              class="btn btn-primary"
            >
              Submit
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';

import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn';
import Sidebar from '../../Navigations/Sidebar';
import TopNavbar from '../../Navigations/TopNavbar';
import TextEditor from '../../common/TextEditor.vue';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';
import Pagination from '@/components/Navigations/Pagination';
import { marketingContact } from '../../common/responseHandler';

export default {
  components: {
    Sidebar,
    TopNavbar,
    CandidateEditFieldCancelBtn,
    TextEditor,
    Pagination,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return 'Employer | Jobshark';
  },
  data: () => ({
    mailIcon: `<svg height="30" id="Glyph" viewBox="0 0 64 64" width="30" xmlns="http://www.w3.org/2000/svg">
  <path d="m26.82 32c-3.31617-3.22622-7.52377-7.36013-10.82-10.57v21.14c1.26408-1.24446 9.37055-9.15463 10.82-10.57z"/>
  <path d="m48 21.43c-3.27936 3.2124-7.51574 7.35022-10.81 10.57 1.46 1.42986 9.53517 9.33167 10.81 10.57z"/>
  <path d="m29.68 32.01a3.0655 3.0655 0 0 0 4.42.22c1.07483-1.04416 10.583-10.346 12.5-12.23h-29.2s9.4 9.22265 12.28 12.01z"/>
  <path d="m46.42 43.82c-1.14841-1.09419-9.32561-9.1256-10.66-10.42a5.058 5.058 0 0 1 -7.5-.00005c-1.44847 1.41518-9.64694 9.42318-10.85005 10.60005h29.19005z"/>
</svg>
`,
    multipleMailIcon: `
<svg id="Glyph" height="30" viewBox="0 0 64 64" width="30" xmlns="http://www.w3.org/2000/svg"><path d="m30.707 7.707.293-.293v2.9195a1.00019 1.00019 0 0 0 2-.00007v-2.91937l.293.293a1.00008 1.00008 0 0 0 1.414-1.4141l-1.99966-1.99969a1.00952 1.00952 0 0 0 -1.41468 0l-1.99966 1.99973a1.00008 1.00008 0 0 0 1.414 1.414z"/><path d="m12.9082 16.73633c.78565-.00887 1.08493-.72252.99995-1.41408l2.064 2.064a1.00008 1.00008 0 0 0 1.414-1.4141l-2.06388-2.06395h.41406a1.00019 1.00019 0 0 0 -.00006-2h-2.82807a1.01 1.01 0 0 0 -1 1v2.82812a1.00006 1.00006 0 0 0 1 1.00001z"/><path d="m10.3335 31h-2.91944l.293-.293a1.00008 1.00008 0 0 0 -1.4141-1.414l-1.99969 1.99966a1.00951 1.00951 0 0 0 0 1.41468l1.99973 1.99966a.99988.99988 0 1 0 1.414-1.414l-.29294-.293h2.91944a1.00019 1.00019 0 0 0 0-2z"/><path d="m15.97217 46.61377-2.064 2.064v-.41406a1.00019 1.00019 0 0 0 -2 .00006c.01252 4.34886-.51862 3.815 3.82815 3.828a1.00017 1.00017 0 0 0 -.00009-2h-.414l2.064-2.064a1.00008 1.00008 0 0 0 -1.41406-1.414z"/><path d="m33.293 56.293-.293.293v-2.9195a1.00019 1.00019 0 0 0 -2 .00007v2.91937l-.293-.293a1.00008 1.00008 0 0 0 -1.414 1.4141l1.99964 1.99966a1.008 1.008 0 0 0 1.41468 0l1.99968-1.9997a1.00008 1.00008 0 0 0 -1.414-1.414z"/><path d="m51.0918 47.26367c-.7856.00893-1.08495.72244-.99995 1.41408l-2.064-2.064a1.00008 1.00008 0 0 0 -1.414 1.4141l2.06391 2.06393h-.41406a1.00019 1.00019 0 0 0 .00006 2h2.82804a1.01 1.01 0 0 0 1-1v-2.82811a1.00006 1.00006 0 0 0 -1-1z"/><path d="m59.92279 32.38214a1.00669 1.00669 0 0 0 -.21607-1.08948l-1.99972-1.99966c-1.25255-1.01007-2.42868.80682-1.121 1.707h-2.9195a1.00019 1.00019 0 0 0 .00007 2h2.91937l-.293.293a.99989.99989 0 1 0 1.41406 1.414 26.98526 26.98526 0 0 0 2.21579-2.32486z"/><path d="m51.47394 11.98541a27.4927 27.4927 0 0 0 -3.21027-.07723 1.0002 1.0002 0 0 0 .00006 2h.414l-2.064 2.064a.99989.99989 0 0 0 1.41406 1.41406l2.064-2.064v.41406a1.00019 1.00019 0 0 0 2-.00006v-2.82804a1.00731 1.00731 0 0 0 -.61785-.92279z"/><path d="m26.82 32c-3.31617-3.22622-7.52377-7.36013-10.82-10.57v21.14c1.26408-1.24446 9.37055-9.15463 10.82-10.57z"/><path d="m48 21.43c-3.27936 3.2124-7.51574 7.35022-10.81 10.57 1.46 1.42986 9.53517 9.33167 10.81 10.57z"/><path d="m29.68 32.01a3.0655 3.0655 0 0 0 4.42.22c1.07483-1.04416 10.583-10.346 12.5-12.23h-29.2s9.4 9.22265 12.28 12.01z"/><path d="m46.42 43.82c-1.14841-1.09419-9.32561-9.1256-10.66-10.42a5.058 5.058 0 0 1 -7.5-.00005c-1.44847 1.41518-9.64694 9.42318-10.85005 10.60005h29.19005z"/></svg>`,
    emailSuggestions: [],
    totalPages: 1,
    totalPagesNew: 1,
    isActionPerforming: false,
    action: 'edit',
    contact: '',
    countryCode: '',
    isAdding: false,
    addEmployer: {
      name: '',
      postalCode: '',
      city: '',
      country: '',
      employees: '',
      website: '',
    },
    tab: 1,
    searchText: '',
    isConnected: false,
    editAboutUs: false,
    editBenefits: false,
    selectedAvatar: '',
    componentKey: 0,
    aboutUsEditor: '',
    benefitsEditor: '',
    selectedName: '',
    selectedOrgo: '',
    selectedVat: '',
    selectedCity: {},
    selectedCountry: {},
    selectedWebsite: '',
    selectedFirstName: '',
    selectedLastName: '',
    selectedTitle: '',
    selectedEmail: '',
    selectedInvoice: '',
    selectedPostalCode: '',
    selectedStreet: '',
    selectedCountryCode: '',
    selectedPhone: '',
    selectedDescription: '',
    selectedAddress: '',
    selectedSecondaryEmail: '',
    selectedVat: '',
    isCareerPortalEnabled: false,
    /*    aboutus: '',
    benefits: '', */
    currentAddress: '',
    employerAvatar: '',
    previewAvatar: '',
    employerStatusOptions: [
      { value: 0, label: 'Advertising' },
      { value: 1, label: 'Recruiting' },
      { value: 2, label: 'Internal' },
    ],
    selectedEmployerStatus: 0,
    actualEmployerStatus: 0,
    key: 0,
    careerPortal: false,
    relocation: false,
    showModal: false,
    employerStatusModalShow: false,
    isInGlobalEditMode: false,
    isToggled: false,
    isLoading: false,
    isNotificationEnabled: false,
    employerData: {},
    editFields: {
      invoiceEmail: false,
      vat: false,
      employerName: false,
      orgo: false,
      firstName: false,
      streetAddress: false,
      lastName: false,
      postalCode: false,
      title: false,
      city: false,
      country: false,
      email: false,
      website: false,
      phone: false,
      emailSync: false,
      imap_email: '',
      notifications: false,
      careerPortal: false,
    },
    editIconState: {
      invoiceEmailFormShow: false,
      vatFormShow: false,
      employerNameFormShow: false,
      orgoFormShow: false,
      firstNameFormShow: false,
      streetAddressFormShow: false,
      lastNameFormShow: false,
      postalCodeFormShow: false,
      titleFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      emailFormShow: false,
      websiteFormShow: false,
      phoneFormShow: false,
      emailSyncFormShow: false,
      notificationsFormShow: false,
      careerPortalFormShow: false,
      isReadonly: false,
    },
    /* Agremeent statuses */
    basic: [
      { id: 1, label: 'Hide' },
      { id: 2, label: 'Promote' },
    ],
    sourcing: [
      { id: 1, label: 'Hide' },
      { id: 2, label: 'Promote' },
      { id: 3, label: 'Agreement' },
    ],

    marketingEmployer: {
      id: '',
      name: '',
      postal_code: '',
      country: '',
      city: '',
      website: '',
      employees: '',
      recruting_agency: '',
      creator: '',
      created_at: '',
    },

    marketingEmployerEdit: {
      id: '',
      name: '',
      postal_code: '',
      country: '',
      city: '',
      website: '',
      employees: '',
      recruting_agency: '',
      creator: '',
      created_at: '',
    },

    addContact: {
      email: '',
      mm_employer_id: '',
      first_name: '',
      last_name: '',
      title: '',
      phone_number: '',
      linkedIn: '',
      language: '',
      advertised_job: '',
      only_newsletter: false,
    },
    countryLanguageMap: {
      Denmark: 'Danish',
      Netherlands: 'Dutch',
      Finland: 'Finnish',
      France: 'French',
      Germany: 'German',
      Austria: 'German',
      Switzerland: 'German',
      Iceland: 'Icelandic',
      Norway: 'Norwegian',
      Poland: 'Polish',
      Spain: 'Spanish',
      Sweden: 'Swedish',
    },
    addJob: {
      step: 1,
      title: '',
      office: '',
      city: '',
      country: '',
      postalCode: '',
      salary: '',
      currency: '',
      linkedin: '',
      fullTime: true,
      workplace: 2,
      description: '',
      source: '',
      url: '',
      sourceUrl: '',
    },
    searchWord: '',
    currentPage: 1,
    currentPageNew: 1,
    contacts: [],
    recruiters: [],
    jobs: [],
    check: {
      status: true,
      jobId: '',
    },

    bouncer: {
      error: 0,
      bouncer_reason: '',
      bouncer_score: '',
      bouncer_status: '',
      bouncer_toxicity: '',
      data: '',
    },
    hybridSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 22" fill="none">
  <path d="M21.8418 20.2776H20.0237C19.8355 20.2776 19.6828 20.1198 19.6828 19.9255V16.8744C19.6828 16.8096 19.6318 16.7571 19.5691 16.7571H17.5236C17.4609 16.7571 17.41 16.8096 17.41 16.8744V19.9255C17.41 20.1198 17.2573 20.2776 17.0691 20.2776H15.2509C14.8123 20.2776 14.4554 19.9091 14.4554 19.4561V15.1142H13.66C13.3468 15.1142 13.0918 14.8508 13.0918 14.5274C13.0918 14.3721 13.1532 14.2199 13.26 14.1097L18.3105 9.10964C18.4423 8.97908 18.6505 8.97908 18.7823 9.10964L23.8278 14.104C23.9395 14.2199 24.0009 14.3721 24.0009 14.5274C24.0009 14.8508 23.746 15.1142 23.4328 15.1142H22.6373V19.4561C22.6373 19.9091 22.2804 20.2776 21.8418 20.2776ZM20.3646 19.5735H21.8418C21.9037 19.5735 21.9554 19.5199 21.9554 19.4561V14.7621C21.9554 14.5678 22.1082 14.4101 22.2963 14.4101H23.1514L18.5463 9.85172L13.9414 14.4101H14.7963C14.9845 14.4101 15.1373 14.5678 15.1373 14.7621V19.4561C15.1373 19.5199 15.1891 19.5735 15.2509 19.5735H16.7282V16.8744C16.7282 16.4214 17.085 16.053 17.5236 16.053H19.5691C20.0078 16.053 20.3646 16.4214 20.3646 16.8744V19.5735Z" fill="#161616"></path>
  <path d="M3.62774 12.8074H5.38315V10.4924C5.38315 10.296 5.52982 10.1367 5.71063 10.1367H7.38043C7.56125 10.1367 7.70775 10.296 7.70775 10.4924V12.8074H9.46317V3.45436V0.711599H3.62774V3.45436V12.8074ZM4.32424 7.34242H5.33248V8.43812H4.32424V7.34242ZM7.75843 7.34242H8.76667V8.43812H7.75843V7.34242ZM6.04141 7.34242H7.04965V8.43812H6.04141V7.34242ZM4.32424 4.70603H5.33248V5.80173H4.32424V4.70603ZM7.75843 4.70603H8.76667V5.80173H7.75843V4.70603ZM6.04141 4.70603H7.04965V5.80173H6.04141V4.70603ZM4.32424 2.06947H5.33248V3.16517H4.32424V2.06947ZM7.75843 2.06947H8.76667V3.16517H7.75843V2.06947ZM6.04141 2.06947H7.04965V3.16517H6.04141V2.06947ZM0.322914 13.519C-0.107638 13.519 -0.107638 12.8074 0.322914 12.8074H0.578318V4.46643C0.578318 4.305 0.677301 4.16869 0.812792 4.12509L2.97295 3.2122V0.355885C2.97295 0.159387 3.11945 0 3.30027 0H9.79064C9.97146 0 10.118 0.159387 10.118 0.355885V3.2122L12.2781 4.12509C12.4136 4.16869 12.5126 4.305 12.5126 4.46643V12.8074H12.768C13.1985 12.8074 13.1985 13.519 12.768 13.519C8.61969 13.519 4.47122 13.519 0.322914 13.519ZM6.03795 12.8074H7.05296V10.8483H6.03795V12.8074ZM11.8578 4.70842L10.118 3.97322V12.8074H11.8578V4.70842ZM2.97295 3.97322L1.23311 4.70842V12.8074H2.97295V3.97322Z" fill="#161616"></path>
  <path d="M12.2268 19.4603L12.2281 19.4602L12.2263 19.4715C12.2101 19.5761 12.1514 19.6596 12.0907 19.7312C12.0715 19.754 12.0507 19.777 12.0307 19.7991C12.0197 19.8112 12.009 19.8231 11.9989 19.8346C11.9693 19.868 11.9429 19.8999 11.9218 19.9323L11.9221 19.9325L11.9186 19.9368C11.8343 20.0394 11.7506 20.1431 11.6668 20.2469C11.5025 20.4504 11.3376 20.6545 11.1669 20.8535L11.1671 20.8537L11.1634 20.8572C11.1031 20.9145 11.032 20.9319 10.9647 20.9203C10.8993 20.909 10.8407 20.8709 10.7987 20.8223C10.7568 20.7739 10.7278 20.7107 10.7275 20.6451C10.7272 20.5793 10.7561 20.5154 10.8201 20.4683L11.4173 19.7346C8.2874 19.7153 5.17776 18.6505 2.79782 16.7235C2.1823 16.2444 1.62035 15.7042 1.11176 15.1228L1.11168 15.1229L1.10971 15.1203C1.06277 15.0591 1.05493 14.9909 1.0741 14.9294C1.09265 14.8698 1.13543 14.819 1.18614 14.7839C1.23692 14.7487 1.29994 14.7263 1.36317 14.7285C1.42735 14.7307 1.49006 14.7586 1.53509 14.8199C3.50998 17.0715 6.35008 18.6152 9.40241 19.0683L9.40257 19.0683C10.0714 19.1699 10.7489 19.2217 11.4273 19.2274C11.3576 19.1414 11.2856 19.0556 11.2132 18.9694C11.0568 18.783 10.8988 18.5948 10.7599 18.3981L10.7583 18.3992L10.7536 18.386C10.7044 18.2476 10.8022 18.1323 10.9075 18.0851C10.9619 18.0606 11.0251 18.0502 11.0849 18.0628C11.1446 18.0754 11.1989 18.1109 11.2335 18.1734C11.3541 18.3209 11.4756 18.4681 11.5971 18.6154C11.7952 18.8555 11.9935 19.0958 12.1886 19.338L12.1889 19.3378L12.1922 19.3432C12.2156 19.3812 12.2242 19.4229 12.2268 19.4603Z" fill="#161616" stroke="#161616" stroke-width="0.1"></path>
  <path d="M12.5441 1.45064L12.5427 1.45043L12.5472 1.43912C12.5865 1.33987 12.6657 1.27083 12.7439 1.21404C12.7688 1.19591 12.7953 1.17792 12.8209 1.16058C12.8349 1.15104 12.8487 1.1417 12.8617 1.13264C12.8997 1.10627 12.9342 1.08071 12.9631 1.05344L12.9629 1.05322L12.9674 1.04988C13.0772 0.967504 13.1866 0.884091 13.2961 0.800541C13.511 0.636762 13.7264 0.472464 13.9469 0.314431L13.9468 0.314223L13.9511 0.311714C14.0251 0.269306 14.1011 0.267755 14.167 0.292784C14.2315 0.317276 14.2843 0.366296 14.3179 0.422847C14.3515 0.479179 14.3688 0.547746 14.3549 0.612955C14.341 0.678789 14.2966 0.734694 14.2208 0.766518L13.4427 1.35509C16.7078 2.04254 19.7309 3.74761 21.8092 6.13994C22.3507 6.73974 22.8234 7.38792 23.2316 8.06493L23.2317 8.06488L23.2332 8.06784C23.2696 8.13827 23.2634 8.20768 23.2299 8.26444C23.1977 8.31893 23.1424 8.35911 23.0829 8.38226C23.0231 8.40551 22.9539 8.41367 22.8899 8.39838C22.8254 8.38295 22.7663 8.34336 22.7322 8.27366C21.1458 5.65051 18.505 3.53373 15.4104 2.43786L15.4103 2.43781C14.7315 2.19502 14.033 1.99922 13.3237 1.84839C13.379 1.94868 13.4363 2.04829 13.4938 2.14838C13.5176 2.18961 13.5413 2.23093 13.565 2.2724C13.6639 2.4455 13.7609 2.62072 13.8449 2.80091L13.848 2.80747L13.8491 2.81462C13.86 2.88671 13.8337 2.94814 13.7897 2.99293C13.7467 3.0367 13.687 3.06492 13.626 3.07695C13.5092 3.10001 13.3574 3.06577 13.3094 2.92226C13.2147 2.75237 13.119 2.58255 13.0232 2.41262C12.8671 2.13559 12.7109 1.85825 12.5583 1.57978L12.5579 1.57999L12.5556 1.57385C12.539 1.53125 12.5389 1.48813 12.5441 1.45064Z" fill="#161616" stroke="#161616" stroke-width="0.1"></path>
</svg>`,

    remoteSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 18 18" fill="none">
  <path d="M8.99939 0.000331702C8.83827 -0.0065736 8.70671 0.0954065 8.60209 0.206259C5.81165 2.88128 3.01987 5.55495 0.230264 8.23081C-0.0291998 8.49912 -0.0792651 8.94541 0.130699 9.25742C0.29086 9.51772 0.600391 9.66439 0.9029 9.64401C1.36128 9.64401 1.81967 9.64401 2.27805 9.64401C2.27865 12.0395 2.27686 14.4351 2.27894 16.8306C2.29093 17.3744 2.71445 17.8719 3.24838 17.9734C3.46999 18.0154 3.69659 17.9921 3.92072 17.9982C4.7985 17.9977 5.67631 17.9991 6.55408 17.9975C6.80297 17.9897 7.00936 17.7523 6.98576 17.5051C6.98602 15.867 6.98524 14.229 6.98615 12.591C6.9893 12.4136 7.16486 12.2798 7.33625 12.3022C8.46555 12.3024 9.59485 12.3016 10.7241 12.3025C10.902 12.3057 11.0344 12.4815 11.013 12.6526C11.0134 14.2906 11.0122 15.9286 11.0136 17.5666C11.0201 17.816 11.2592 18.0217 11.5062 17.9982C12.527 17.9972 13.5478 18.0003 14.5685 17.9966C15.1067 17.9775 15.5952 17.5564 15.696 17.028C15.738 16.8064 15.7146 16.5798 15.7207 16.3557C15.7207 14.1184 15.7207 11.8812 15.7207 9.64397C16.2234 9.64225 16.7263 9.64746 17.2288 9.64129C17.6344 9.617 17.9864 9.25926 17.9984 8.85217C18.0167 8.57713 17.8796 8.31231 17.6725 8.13739C14.8806 5.46227 12.0897 2.78607 9.29715 0.111621C9.21557 0.0402153 9.1078 -6.60649e-06 8.99939 0.000331702ZM8.99939 1.08614C11.6592 3.6355 14.319 6.18486 16.9788 8.73423C16.3942 8.73543 15.8096 8.73182 15.2252 8.73604C14.9793 8.75222 14.7868 8.99234 14.8108 9.23498C14.8103 11.759 14.8121 14.283 14.81 16.807C14.8013 16.9809 14.6291 17.1099 14.4604 17.0884C13.6145 17.0884 12.7687 17.0884 11.9229 17.0884C11.9223 15.5789 11.9241 14.0694 11.922 12.5599C11.91 12.0162 11.4866 11.5187 10.9527 11.4171C10.731 11.3751 10.5044 11.3985 10.2803 11.3924C9.26545 11.3932 8.25059 11.3907 7.23581 11.3936C6.70382 11.4092 6.21839 11.8183 6.10718 12.3377C6.05598 12.5667 6.08245 12.8023 6.07587 13.0348C6.07587 14.386 6.07587 15.7372 6.07587 17.0884C5.2045 17.0874 4.333 17.0905 3.46172 17.0868C3.2871 17.0732 3.16684 16.8979 3.18794 16.7303C3.18755 14.2088 3.18874 11.6873 3.18735 9.16579C3.18091 8.91643 2.94174 8.71075 2.69477 8.73423C2.13652 8.73423 1.57827 8.73423 1.02002 8.73423C3.67981 6.18486 6.3396 3.6355 8.99939 1.08614Z" fill="#161616"></path>
</svg>`,
    onsiteSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none">
  <path d="M4.98815 17.0525H7.40184V13.9701C7.40184 13.7087 7.6035 13.4965 7.85212 13.4965H10.1481C10.3967 13.4965 10.5982 13.7087 10.5982 13.9701V17.0525H13.0119V4.59933V0.947464H4.98815V4.59933V17.0525ZM5.94583 9.77612H7.33216V11.235H5.94583V9.77612ZM10.6678 9.77612H12.0542V11.235H10.6678V9.77612ZM8.30694 9.77612H9.69327V11.235H8.30694V9.77612ZM5.94583 6.26588H7.33216V7.72476H5.94583V6.26588ZM10.6678 6.26588H12.0542V7.72476H10.6678V6.26588ZM8.30694 6.26588H9.69327V7.72476H8.30694V6.26588ZM5.94583 2.75541H7.33216V4.21429H5.94583V2.75541ZM10.6678 2.75541H12.0542V4.21429H10.6678V2.75541ZM8.30694 2.75541H9.69327V4.21429H8.30694V2.75541ZM0.444006 18C-0.148002 18 -0.148002 17.0525 0.444006 17.0525H0.795187V5.94687C0.795187 5.73192 0.931288 5.55044 1.11759 5.49238L4.0878 4.27691V0.473846C4.0878 0.212217 4.28925 0 4.53787 0H13.4621C13.7108 0 13.9122 0.212217 13.9122 0.473846V4.27691L16.8824 5.49238C17.0687 5.55044 17.2048 5.73192 17.2048 5.94687V17.0525H17.556C18.148 17.0525 18.148 18 17.556 18C11.8521 18 6.14793 18 0.444006 18ZM8.30218 17.0525H9.69782V14.444H8.30218V17.0525ZM16.3045 6.26907L13.9122 5.29018V17.0525H16.3045V6.26907ZM4.0878 5.29018L1.69553 6.26907V17.0525H4.0878V5.29018Z" fill="#161616"/>
</svg>`,
    fulltimeSvg: `<?xml version="1.0"?>
<svg xmlns="http://www.w3.org/2000/svg" id="line" viewBox="0 0 64 64"><path d="M29.34082,57.86523a26.0101,26.0101,0,1,1,25.43457-13.331,1.00059,1.00059,0,0,0,1.75.9707A27.99782,27.99782,0,1,0,29.13965,59.85547c.03418.00293.06836.00488.10156.00488a1.00009,1.00009,0,0,0,.09961-1.99512Z"/><path d="M36,32a3.99552,3.99552,0,0,0-3-3.858V12a1,1,0,0,0-2,0V28.142A3.99326,3.99326,0,0,0,28.142,31H17a1,1,0,0,0,0,2H28.142A3.99158,3.99158,0,0,0,36,32Zm-4,2a2,2,0,1,1,2-2A2.0026,2.0026,0,0,1,32,34Z"/><path d="M55.43262,48.10254l-5.30506-1.76917c6.52381-4.02148,3.66254-14.33709-4.10919-14.33331-7.77386.002-10.63544,10.30628-4.10858,14.3338l-5.30627,1.76868a6.67111,6.67111,0,0,0-4.56739,6.33691V57.377A2.6261,2.6261,0,0,0,34.65918,60H57.377A2.6261,2.6261,0,0,0,60,57.377v-2.9375A6.67112,6.67112,0,0,0,55.43262,48.10254ZM40.25684,39.76172c.24243-7.614,11.28155-7.6131,11.52246.00012C51.5376,47.37537,40.49774,47.37268,40.25684,39.76172ZM58,57.377a.6235.6235,0,0,1-.623.623H34.65918a.6235.6235,0,0,1-.623-.623v-2.9375a4.67553,4.67553,0,0,1,3.2002-4.44043l6.14941-2.04882a8.37792,8.37792,0,0,1,5.26465-.001L54.7998,49.999A4.67552,4.67552,0,0,1,58,54.43945Z"/></svg>
`,
    linkedinIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M512 96L127.9 96C110.3 96 96 110.5 96 128.3L96 511.7C96 529.5 110.3 544 127.9 544L512 544C529.6 544 544 529.5 544 511.7L544 128.3C544 110.5 529.6 96 512 96zM231.4 480L165 480L165 266.2L231.5 266.2L231.5 480L231.4 480zM198.2 160C219.5 160 236.7 177.2 236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160zM480.3 480L413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480z"/></svg>`,
  }),
  methods: {
    ...mapActions([
      'retrieveUserProfile',
      'updateEmployerById',
      'addEmployerComment',
      'editEmployerComment',
      'retrieveEmployerById',
      'setEmployerAgreement',
      'removeEmployerComment',
      'retrieveEmployerComments',
      'retrieveCitiesListByCountryId',
      'retrieveActivitiesForEmployer',
      'retrieveEmployerDocumentPreview',
    ]),
    /*     chnageAgreement(name, id) {
      this.selectedAgreements[name] = {
        [name]: id,
      };
    }, */

    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.addContact.phone_number = code.substring(0, code.indexOf(' ')) + ' ';
    },

    setAction(contact, action) {
      this.action = action;
      this.contact = { ...contact };
    },

    getLanguageFlag(language) {
      const languageFlagMap = {
        danish: 'dk',
        dutch: 'nl',
        english: 'gb',
        finnish: 'fi',
        french: 'fr',
        german: 'de',
        icelandic: 'is',
        norwegian: 'no',
        polish: 'pl',
        spanish: 'es',
        swedish: 'se',
      };
      return languageFlagMap[(language || '').toLowerCase()] || 'gb';
    },

    getLanguageName(language) {
      const lang = (language || '').toLowerCase();
      const known = [
        'danish',
        'dutch',
        'english',
        'finnish',
        'french',
        'german',
        'icelandic',
        'norwegian',
        'polish',
        'spanish',
        'swedish',
      ];
      const display = known.includes(lang) ? lang : 'english';
      return display.charAt(0).toUpperCase() + display.slice(1);
    },

    getIconColor(status) {
      if (status === 0) {
        return { fill: '#a3a6b4' };
      } else if (status === 1) {
        return { fill: '#c8c8c8', opacity: 0.5 };
      } else {
        return { fill: '#a3a6b4' };
      }
    },

    getWorkPlacePopper(workplace) {
      if (workplace === 1) {
        return 'On-site';
      } else if (workplace === 2) {
        return `Hybrid`;
      } else {
        return `Remote`;
      }
    },

    changeStep(step) {
      this.addJob.step = step;
    },

    setJobForCheck(id, status) {
      this.check.status = status;
      this.check.jobId = id;
    },

    setContact(name, title, linkedin) {
      if (name) {
        this.addContact.first_name = name;
        this.addContact.last_name = name;
      }
      if (title) {
        this.addContact.title = title;
      }
      if (linkedin) {
        this.addContact.linkedIn = linkedin;
      }
    },

    checkJob(jobId, status) {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/check`,
          {
            mm_job_id: jobId,
            check: status,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeUserCheckNeww.click();
          this.check.id = '';
          this.check.status = true;
          this.getMarketingEmployerJobs();
        });
    },

    getLanguageByCountry(country) {
      return this.countryLanguageMap[country] || 'English';
    },
    clearFieldsAddContact() {
      this.addContact.email = '';
      this.addContact.mm_employer_id = '';
      this.addContact.first_name = '';
      this.addContact.last_name = '';
      this.addContact.title = '';
      this.addContact.phone_number = '';
      this.addContact.linkedIn = '';
      this.addContact.language = this.getLanguageByCountry(this.marketingEmployer.country);
      this.addContact.only_newsletter = false;
      /* this.addContact.advertised_job = ''; */
      this.bouncer.error = 0;
      this.bouncer.bouncer_reason = '';
      this.bouncer.bouncer_score = '';
      this.bouncer.bouncer_status = '';
      this.bouncer.bouncer_toxicity = '';
      this.bouncer.data = '';
      this.countryCode = '';
    },

    clearFields() {},

    getLatestJob() {
      if (this.contacts.length > 0) {
        this.addContact.advertised_job = this.contacts[0].advertised_job;
      }
    },

    clearJobFields() {
      this.addJob.step = 1;
      this.addJob.title = '';
      this.addJob.office = '';
      this.addJob.city = '';
      this.addJob.country = '';
      this.addJob.postalCode = '';
      this.addJob.salary = '';
      this.addJob.currency = '';
      this.addJob.linkedin = '';
      this.addJob.fullTime = true;
      this.addJob.workplace = 1;
      this.addJob.description = '';
      this.addJob.source = '';
      this.addJob.url = '';
      this.addJob.sourceUrl = '';
    },
    addJobForEmployer() {
      this.isAdding = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/create`,
          {
            mm_employer_id: this.$route.params.employer_id,
            job_title: this.addJob.title,
            office: this.addJob.office,
            city: this.addJob.city.name,
            country: this.addJob.country.name,
            linkedin: this.addJob.linkedin,
            full_time: this.addJob.fullTime,
            workplace: this.addJob.workplace,
            description: this.addJob.description,
            url: this.addJob.url,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeJob.click();
          this.isAdding = false;
          this.getMarketingEmployerJobs();
          this.clearJobFields();
          this.$toasted.success('Job created successfully!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.isAdding = false;
          this.$toasted.error('Error creating job', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    addUserContact() {
      this.isAdding = true;
      this.addContact.email = this.addContact.email.replace(/\s+/g, '');
      const emailRegex = /^(?:[^\s@]+@[^\s@]+\.[^\s@]+|\*\@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+)$/i;
      if (!emailRegex.test(this.addContact.email)) {
        this.isAdding = false;
        this.$toasted.error(`Please enter a valid email address`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/create`,
          {
            email: this.addContact.email,
            mm_employer_id: this.$route.params.employer_id,
            first_name: this.addContact.first_name,
            last_name: this.addContact.last_name,
            title: this.addContact.title,
            phone_number: this.addContact.phone_number,
            linkedin: this.addContact.linkedIn,
            language: this.addContact.language,
            advertised_job: this.addContact.advertised_job,
            only_newsletter: this.addContact.only_newsletter,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          const meta = marketingContact.find(
            x => x.internal_code === Number(res.data.internal_code),
          );
          if (meta && meta.toast === true) {
            this.$toasted.success(meta.message, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          }
          this.$refs.closeUser.click();
          this.emailSuggestions = res.data;
          this.getMarketingEmployerContacts();
          this.clearFieldsAddContact();
          this.isAdding = false;
        })
        .catch(err => {
          this.isAdding = false;
          this.getMarketingEmployerContacts();
          if (err.response.data.bouncer_reason) {
            const error = err.response.data;
            if (err.response.data.bouncer_reason) {
              this.bouncer.error = 1;
              this.bouncer.bouncer_reason = error.bouncer_reason;
              this.bouncer.bouncer_score = error.bouncer_score;
              this.bouncer.bouncer_status = error.bouncer_status;
              this.bouncer.bouncer_toxicity = error.bouncer_toxicity;
              this.bouncer.data = error.data;
            }
          } else {
            const meta = marketingContact.find(
              x => x.internal_code === Number(err.response.data.internal_code),
            );
            if (meta && meta.toast === true) {
              this.$toasted.error(`${meta.message}`, {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            }
          }
        });
    },

    getMarketingEmployer() {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/marketing/employers/index/${this.$route.params.employer_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.marketingEmployer = res.data;
          this.marketingEmployerEdit = JSON.parse(JSON.stringify(this.marketingEmployer));
          this.addContact.language = this.getLanguageByCountry(this.marketingEmployer.country);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getMarketingEmployerContacts() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/search`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: 'all_time',
            js_profile_ids: [],
            mm_employers_ids: [this.$route.params.employer_id],
            include_declined_contacts: true,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.isLoading = false;
          this.contacts = res.data.data;
          this.totalPages = res.data.last_page;
          this.getLatestJob();
        })
        .catch(err => {
          console.log(err);
        });
    },

    nextPage() {
      if (this.currentPage >= 1) {
        this.currentPage++;
        this.getMarketingEmployerContacts();
      }
    },

    nextPageNew() {
      if (this.currentPageNew >= 1) {
        this.currentPageNew++;
        this.getMarketingEmployerJobs();
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;

        this.getMarketingEmployerContacts();
      } else {
        this.currentPage = 1;
      }
    },

    previousPageNew() {
      if (this.currentPageNew > 1) {
        --this.currentPageNew;

        this.getMarketingEmployerJobs();
      } else {
        this.currentPageNew = 1;
      }
    },

    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;

      this.currentPage = pageNumber;

      this.getMarketingEmployerContacts();
    },

    setPageByNumberNew(pageNumber) {
      if (pageNumber > this.totalPagesNew || pageNumber < 1) return;

      this.currentPageNew = pageNumber;

      this.getMarketingEmployerJobs();
    },

    setToFirstPage() {
      this.currentPage = 1;

      this.getMarketingEmployerContacts();
    },

    setToFirstPageNew() {
      this.currentPageNew = 1;

      this.getMarketingEmployerJobs();
    },

    setToLastPage(lastPage) {
      this.currentPage = lastPage;

      this.getMarketingEmployerContacts();
    },

    setToLastPageNew(lastPage) {
      this.currentPageNew = lastPage;

      this.getMarketingEmployerJobs();
    },

    getMarketingEmployerRecruiters() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/getrecruiters`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: 'all_time',
            js_profile_ids: [],
            mm_employer_id: this.$route.params.employer_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.recruiters = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMarketingEmployerJobs() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/job/list`,
          {
            search_word: this.searchText,
            page: this.currentPageNew,
            count: 10,
            include_previously_checked_jobs: true,
            mm_employers_ids: [this.$route.params.employer_id],
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.jobs = res.data.data;
          this.totalPagesNew = res.data.last_page;
        });
    },

    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.globalUpdateForm.reset();
    },
    changeGlobalEditMode() {
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
      this.getActualCountry();
    },

    onCancelSetEmployerAgreement() {
      this.employerStatusModalShow = false;
      this.selectedEmployerStatus = this.actualEmployerStatus;
    },
    showEditForm(e) {
      this.getActualCountry();
      if (e.target.id === 'invoice') {
        this.editIconState.invoiceEmailFormShow = !this.editIconState.invoiceEmailFormShow;
      }
      if (e.target.id === 'vat') {
        this.editIconState.vatFormShow = !this.editIconState.vatFormShow;
      }

      if (e.target.id === 'orgo') {
        this.editIconState.orgoFormShow = !this.editIconState.orgoFormShow;
      }

      if (e.target.id === 'first-name') {
        this.editIconState.firstNameFormShow = !this.editIconState.firstNameFormShow;
      }

      if (e.target.id === 'last-name') {
        this.editIconState.lastNameFormShow = !this.editIconState.lastNameFormShow;
      }

      if (e.target.id === 'street-address') {
        this.editIconState.streetAddressFormShow = !this.editIconState.streetAddressFormShow;
      }

      if (e.target.id === 'postal-code') {
        this.editIconState.postalCodeFormShow = !this.editIconState.postalCodeFormShow;
      }

      if (e.target.id === 'title') {
        this.editIconState.titleFormShow = !this.editIconState.titleFormShow;
      }

      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }

      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }

      if (e.target.id === 'email') {
        this.editIconState.emailFormShow = !this.editIconState.emailFormShow;
      }

      if (e.target.id === 'website') {
        this.editIconState.websiteFormShow = !this.editIconState.websiteFormShow;
      }

      if (e.target.id === 'phone') {
        this.editIconState.phoneFormShow = !this.editIconState.phoneFormShow;
      }

      if (e.target.id === 'email-sync') {
        this.editIconState.emailSyncFormShow = !this.editIconState.emailSyncFormShow;
      }

      if (e.target.id === 'notifications') {
        this.editIconState.notificationsFormShow = !this.editIconState.notificationsFormShow;
      }

      if (e.target.id === 'career-portal') {
        this.editIconState.careerPortalFormShow = !this.editIconState.careerPortalFormShow;
      }
    },

    updateEmployer() {
      if (this.marketingEmployerEdit.city === null || this.marketingEmployerEdit.country === null) {
        this.$toasted.error(`Please select country and city`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }

      if (!this.marketingEmployerEdit.city) {
        this.$toasted.error(`Please select city`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/update`,
          {
            mm_employer_id: this.$route.params.employer_id,
            name: this.marketingEmployerEdit.name,
            postal_code: this.marketingEmployerEdit.postal_code,
            city: this.marketingEmployerEdit.city.name,
            country: this.marketingEmployerEdit.country.name,
            employees: this.marketingEmployerEdit.employees,
            website: this.marketingEmployerEdit.website,
            recruting_agency: this.marketingEmployerEdit.recruting_agency,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.isInGlobalEditMode = false;
          for (const key in this.editIconState) {
            this.editIconState[key] = false;
          }
          this.getMarketingEmployer();
          this.$toasted.success('Success', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    getActualCountry() {
      if (this.marketingEmployerEdit.country) {
        this.marketingEmployerEdit.country = this.getAllCountries.find(
          c => c.name === this.marketingEmployer.country,
        );
        this.fetchCitiesByCountryId(this.marketingEmployerEdit.country);
      }
    },

    fetchCitiesByCountryId(country) {
      this.retrieveCitiesListByCountryId({ id: country.id }).then(() => {
        this.getActualCity(this.marketingEmployer.city);
      });
    },
    getActualCity(name) {
      this.marketingEmployerEdit.city = this.getCitiesListByCountry.find(c => c.name === name);
    },

    fetchCitiesByCountryIdNew(country) {
      this.retrieveCitiesListByCountryId({ id: country.id });
      this.marketingEmployerEdit.city = '';
    },
    getWorkPlace(workplace) {
      if (workplace === 1) {
        return this.onsiteSvg;
      } else if (workplace === 2) {
        return this.hybridSvg;
      } else {
        return this.remoteSvg;
      }
    },

    addNewEmployer() {
      this.isAdding = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/employers/create`,
          {
            name: this.addEmployer.name,
            postal_code: this.addEmployer.postalCode,
            city: this.addEmployer.city.name,
            country: this.addEmployer.country.name,
            employees: 0,
            website: this.addEmployer.website,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.isAdding = false;
          this.$refs.closeUserCheck.click();
          this.clearEmployerFields();
          this.$toasted.success('New employer created', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.isAdding = false;
        });
    },

    clearEmployerFields() {
      this.addEmployer.name = '';
      this.addEmployer.postalCode = '';
      this.addEmployer.city = '';
      this.addEmployer.country = '';
      this.addEmployer.employees = '';
      this.addEmployer.website = '';
    },

    fetchCitiesByCountryIdAdd(country) {
      // this.selectedCountry = e;
      this.retrieveCitiesListByCountryId({ id: country.id });
    },

    deleteContact(id) {
      this.isActionPerforming = true;
      axios
        .delete(`${process.env.VUE_APP_API_URL}/marketing/contact/delete`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
          data: { contact_id: id },
        })
        .then(() => {
          this.isActionPerforming = false;
          this.$toasted.error('Contact deleted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.getMarketingEmployerContacts();
          this.$refs.actionModalClose.click();
        })
        .catch(err => {
          this.isActionPerforming = false;
        });
    },

    editContact() {
      this.isActionPerforming = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/update`,
          {
            contact_id: this.contact.id,
            first_name: this.contact.first_name,
            last_name: this.contact.last_name,
            title: this.contact.title,
            phone_number: this.contact.phone_number,
            linkedin: this.contact.linkedin,
            language: this.contact.language,
            advertised_job: this.contact.advertised_job,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$toasted.success('Contact updated', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isActionPerforming = false;
          this.$refs.actionModalClose.click();
          this.getMarketingEmployerContacts();
          this.countryCode = '';
        })
        .catch(() => {
          this.isActionPerforming = false;
          this.$toasted.success('There was an error communicating with the server', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    submitContact() {
      this.isActionPerforming = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/submit`,
          {
            contact_id: this.contact.id,
            first_name: this.contact.first_name,
            last_name: this.contact.last_name,
            title: this.contact.title,
            phone_number: this.contact.phone_number,
            linkedin: this.contact.linkedin,
            advertised_job: this.contact.advertised_job,
            language: this.contact.language,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$toasted.success('Contact submitted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isActionPerforming = false;
          this.$refs.actionModalClose.click();
          this.getMarketingEmployerContacts();
          this.countryCode = '';
        })
        .catch(() => {
          this.isActionPerforming = false;
          this.$toasted.error('There was an error communicating with the server', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    addCountryCodeContact(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.contact.phone_number = code.substring(0, code.indexOf(' ')) + ' ';
    },

    removeEmployer() {
      this.isAdding = true;
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/marketing/employers/delete/${this.$route.params.employer_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.isAdding = false;
          this.$refs.closeModalBtnDel.click();
          this.$toasted.success('Employer deleted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          setTimeout(() => {
            this.$router.push({ name: 'admin-marketing-employers' });
          }, 1000);
        })
        .catch(() => {
          this.isAdding = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      'getAccType',
      'getEmployerById',
      'getUserProfile',
      'getEmployerComments',
      'getCitiesListByCountry',
      'getAllCountries',
      'getActivitiesForEmployer',
    ]),

    isContactEmpty() {
      return (
        !this.addContact.first_name ||
        !this.addContact.last_name ||
        !this.addContact.email ||
        !this.addContact.advertised_job
      );
    },

    filteredAgreements(type) {
      return this.getEmployerById.online_agreements_data.filter(item => item.type === type);
    },
  },
  mounted() {
    this.isLoading = false;
    this.getMarketingEmployer();
    this.getMarketingEmployerContacts();
    this.getMarketingEmployerJobs();
    this.getMarketingEmployerRecruiters();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.addjb {
  display: flex;
  width: 100%;
  justify-content: space-around;
  .btn {
    width: 30%;
  }
}

.icons {
  display: flex;
  align-items: center;
  gap: 12px;
  div {
  }
}

b {
  font-weight: 700 !important;
}

.header-contacts {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    margin-bottom: 6px;
  }
}

.custom-header-employer {
  font-size: 16px;
  font-weight: 700;
  border-bottom: 1px solid #ddd;
  margin: 25px 0 12px 0;
  padding-bottom: 12px;
}

.advertising {
  font-family: $font-family-sans-lato;
  padding: 20px 0 0 0;
  margin-left: 12px;
  .form-group {
    margin-bottom: 20px;
    label {
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.test {
  position: absolute;
  padding: 2px 8px;
  top: 28px;
  right: 5px;
  border-radius: 2px;
  cursor: pointer;
  color: #fff;
}

.badge {
  background: mix($color-white, $btn-default-color, 50);
  color: #fff;
  margin-left: 5px;
  text-align: center;
  animation: pulse 2s infinite;
  animation-duration: pulse 10s;
  -webkit-animation-duration: 5s;
}

@keyframes pulse {
  0% {
  }
  50% {
    -moz-box-shadow: 0 0 0 0 $color-orange;
    box-shadow: 0 0 0 0 $color-orange;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.label {
  font-weight: 700;
}

.text-editor {
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 12px;
  margin: 6px 0;
}
#description {
  padding: 0 24px;
}
.card {
  margin: 0 0 24px 0;
  padding-bottom: 30px;
  min-height: 420px;
  .tab-content {
    margin: 1rem;
  }
}

.tech-icons {
  img {
    width: 30px;
    height: auto;
  }

  .icon-container:not(:last-child) {
    margin-right: 20px;
  }
}

.opted-checkbox {
  margin-right: 1rem;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    background-color: transparent;
    padding-right: 4px !important;
    .btn {
      background-color: #fff;
      border: 1px solid rgba(60, 60, 60, 0.26) !important;
      width: 24px;
      height: 24px;
      margin-left: 2px;
      font-size: 12px;
      flex-shrink: 0;
      border-radius: 5px;
      padding: 0;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 2.4px;
      .fa-check {
        color: green;
      }
      .fa-times {
        color: Red;
      }
    }
  }
}

.employer-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.candidate-edit {
  float: right;
  margin-top: 10px;

  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.candidate-info-form {
  /* margin-left: -2rem; */

  button {
    padding-top: 1px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 1px;

    i {
      font-size: 8px;
    }
  }
}

.edit-icon {
  font-size: 1.1rem !important;
}

form {
  input {
    height: 30px;
  }
}

.employer-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin: 0 7px 0 7px;
  overflow: hidden;

  .list-group-item {
    border: none !important;
    .d-flex {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
      margin: 3px 0px;
      padding: 12px 0;
      height: 46px;
      align-items: center;
    }
  }

  li span {
    min-width: 140px !important;
    display: inline-block;
    white-space: nowrap;
    text-align: justify;
    margin-right: 1rem;
  }

  li span:first-child {
    font-weight: 700;
  }

  .edit-btn {
    position: absolute;
    top: 0;
    left: -25px;
    .edit-icon {
      color: #666;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

.form-buttons {
  align-self: center;
  display: flex;
  width: 150px;
  flex-wrap: wrap;
  height: 38px;
  i {
    margin-left: auto;
  }
}

@media only screen and (max-width: 1251px) {
  #description {
    padding: 0;
  }
  .card {
    margin-top: 24px !important;
  }
  .employer-aside {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  #description {
    padding: 0;
    .card {
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      margin: 24px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0;
      }
    }
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .list-group-item {
    .d-flex {
      margin: 3px 12px !important;
    }
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 768px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .no-mobile {
    border: none;
  }
  .temp {
    margin: 1rem;
  }
}

@media only screen and (max-width: 576px) {
  #description {
    padding: 0;
    overflow: hidden;
    .card {
      margin: 0 !important;
    }
  }

  .card .tab-content {
    margin: 1rem;
  }

  .no-mobile {
    border: none !important;
    margin-top: 0 !important;
  }
  .candidate {
    padding: 10px 5px;
    figure {
      width: 43px;
      height: 43px;
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        max-width: 100% !important;
        max-height: 100% !important;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}
</style>
